<template>
  <div class="def-w">
    <div class="flex">

      <div class="left">
        <div class="left-img">
          <img :src="menuBgImg" alt="">
          <h3 class="left-title">{{ parentInfo.name }}</h3>
        </div>
        <ul class="cate-list">
          <li v-for="item in cateList" :key="item.code" class="cate-item" @click="selectCate(item.code)">
            <div class="cate-title" :class="{'active': code === item.code}">{{ item.name }}</div>
          </li>
        </ul>
      </div>
      <div class="right flex-1">
        <router-view :cate-info="curCateInfo" :three-list="threeList" />
      </div>
    </div>
  </div>
</template>

<script>
import { TOP_NAV_MENU_CODE } from "@/utils/constant";
import { mapGetters } from "vuex";

export default {
  name: "SideNav",
  components: {},
  props: {
  }, data() {
    return {
      code: "",
      parentInfo: {},
      cateList: [],
      threeList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["allMenusTree"]),
    curCateInfo() {
      return this.cateList?.find(item => item.code === this.code) ?? this.parentInfo
    },
    menuBgImg() {
      switch (this.parentInfo.code) {
        case TOP_NAV_MENU_CODE.NEWS_INFO:
          // 信息发布
          return require("@/assets/images/side-nav/xwzx.jpg")
        case TOP_NAV_MENU_CODE.SITE_SERVICE:
          // 场所服务
          return require("@/assets/images/side-nav/csfw.jpg")
        case TOP_NAV_MENU_CODE.PLATFORM_MANAGE:
          // 平台管理
          return require("@/assets/images/side-nav/ptgl.jpg")
        case TOP_NAV_MENU_CODE.SUPERVISION:
          // 监督管理
          return require("@/assets/images/side-nav/jdgl.jpg")
        case TOP_NAV_MENU_CODE.JYZN:
          // 交易指南
          return require("@/assets/images/side-nav/fwzn.jpg")
        case TOP_NAV_MENU_CODE.ABOUT_US:
          // 关于我们
          return require("@/assets/images/side-nav/gywm.jpg")
        case TOP_NAV_MENU_CODE.POLICY_REGULATION:
          // 政策法规
          return require("@/assets/images/side-nav/zcgz.jpg")
        case TOP_NAV_MENU_CODE.RECENT_OPEN_BIDDING:
          // 近期开标
          return require("@/assets/images/side-nav/jqkb.jpg")
        default:
          return require("@/assets/images/side-nav/jggg.jpg")
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const params = this.$route.params
    this.code = params.code
    this.menuId = this.$getMenuIdByCode(params.code || TOP_NAV_MENU_CODE.NEWS_INFO)
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    // 判断 menuId 是第几级 ID
    getMenuLevel(menuId, menusTree) {
      const findLevel = (id, tree, level = 1) => {
        for (const item of tree) {
          if (item.id === id) {
            return level;
          }
          if (item.children && item.children.length > 0) {
            const childLevel = findLevel(id, item.children, level + 1);
            if (childLevel) {
              return childLevel;
            }
          }
        }
        return null;
      };
      return findLevel(menuId, menusTree);
    },
    checkMenuLevel() {
      const level = this.getMenuLevel(this.menuId, this.allMenusTree);
      // `Menu ID ${this.menuId} 是第 ${level} 级`
      if (level === 1) {
        // 一级逻辑
        const item = this.allMenusTree.find(item => item.id === this.menuId);
        if (item) {
          this.parentInfo = item;
          const children = item.children;
          this.cateList = children && children.length > 0 ? children : [this.parentInfo];
        }
      } else if (level === 2) {
        // 二级逻辑
        const item = this.allMenusTree.find(item => item.id === this.menuId);
        if (item) {
          this.parentInfo = item;
          const children = item.children;
          this.cateList = children && children.length > 0 ? children : [this.parentInfo];
        } else {
          for (const item of this.allMenusTree) {
            if (item.children) {
              const parent = item.children.find(child => child.id === this.menuId);
              if (parent) {
                this.parentInfo = item;
                this.cateList = item.children;
                this.threeList = parent.children || [];
                break;
              }
            }
          }
        }
      } else if (level === 3) {
        // 三级逻辑
        let found = false;
        for (const item of this.allMenusTree) {
          if (item.children) {
            for (const child of item.children) {
              if (child.id === this.menuId) {
                // 如果直接找到三级菜单，设置父级为第二级
                this.parentInfo = item;
                this.cateList = item.children; // 二级菜单的所有兄弟节点
                this.threeList = child.children || [];
                found = true;
                break;
              } else if (child.children) {
                // 如果三级菜单嵌套在更深层次，递归查找
                const grandChild = child.children.find(grand => grand.id === this.menuId);
                if (grandChild) {
                  this.parentInfo = child; // 第二级
                  this.cateList = item.children; // 二级菜单的所有兄弟节点
                  this.threeList = child.children || []; // 第三级赋值给 threeList
                  found = true;
                  break;
                }
              }
            }
          }
          if (found) break;
        }
      }
    },
    // 初始化
    init() {
      this.checkMenuLevel();
    },
    // 选择分类
    selectCate(code) {
      this.code = code
      this.$router.replace({
        path: this.curCateInfo.path
      })
    }
  }
};
</script>

<style scoped lang="scss">
.left{
	width: 278px;
	.left-img{
		position: relative;
		img{
			display: block;
			width: 100%;
		}
		.left-title{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 0;
			transform: translate(0, -50%);
			color: #fff;
			font-size: 36px;
			text-align: center;
		}
	}
	.cate-list{
		border: 1px solid #ddd;
		padding: 0 20px;
		.cate-item{
			padding: 6px 0;
			font-size: 14px;
			cursor: pointer;
			.cate-title{
				height: 38px;
				line-height: 38px;
				text-align: center;
				&:hover{
					background-color: $--color-primary;
					color: #fff;
				}
			}
			.active{
				background-color: $--color-primary;
				color: #fff;
			}
		}
		.cate-item + .cate-item{
			border-top: 1px solid #ddd;
		}
	}
}
.right{
	width: 0;
	margin-left: 40px;
}

</style>
